import ynToBool from "Utils/ynToBool";

export const hasEncryptedSSO = ynToBool(process.env.REACT_APP_HAS_ENCRYPTED_SSO);
export const authEndpoint = process.env.REACT_APP_AUTH_ENDPOINT;
